<template>
  <div class="popup-wrp" v-if="ad">
    <div class="popup-mask">
      <div class="popup-content" ref="content">
        <img class="img-bg" :src="ad.image" alt="" @click="toAdDetail" />
        <img
          class="img-close"
          src="~images/platform/mutualHelp/help-modal-close.png"
          alt=""
          @click="close"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getAdLists } from 'api/platform/mutualHelpV3.js'
import { commonGetToken } from 'utils/tool.js'
import { addOssParamsForcibly } from 'utils/tool.js'
import { parseParamId } from 'utils/index.js'
import dayjs from 'dayjs'

const KEY_PREFIX = 'qa_common_ad_'

export default {
  data() {
    return {
      ad: null
    }
  },
  mounted() {
    const { isYixinliApp, isMobile } = this.$platform
    // 该广告位只在站外移动端出现
    if (isMobile && !isYixinliApp) {
      commonGetToken(this).then(token => {
        this.fetchAd(token)
      })
    }
  },
  methods: {
    addOssParamsForcibly,
    close() {
      this.ad = null
    },
    fetchAd(token) {
      const params = {
        name: 'qa-m-detail-popup',
        size: 1,
        token: token || ''
      }
      return getAdLists(params).then(res => {
        if (+res.code === 0) {
          const list = res.data || []
          const val = list.length ? list[0] : null
          const cached = this.getCache() // 当天当页面只弹一次
          if (val && !cached) {
            val.image = this.addOssParamsForcibly(val.image, 500)
            this.preloadImage(val.image) // 预加载图片
            setTimeout(() => {
              this.ad = val
              this.setCache()
            }, 9 * 1000) // 需要要求10s后弹出，考虑到前边还有其他耗时，这里近似用9s
          }
        }
      })
    },
    getCache() {
      const key = this.genKey()
      const time = JSON.parse(window.localStorage.getItem(key))
      const now = dayjs().format('YYYY-MM-DD')
      return dayjs(time).isSame(now, 'day')
    },
    setCache() {
      const key = this.genKey()
      window.localStorage.setItem(key, Date.now())
    },
    genKey() {
      return (
        KEY_PREFIX +
        (this.$route.path.indexOf('qa/answer') > 0 ? 'answer_' : 'question_') +
        parseParamId(this.$route.params.id)
      )
    },
    toAdDetail() {
      this.commonToAdPage({
        url: this.ad.url
      })
    },
    preloadImage(imgUrl) {
      const image = new Image()
      const handler = () => {
        console.log('common ad img loaded!')
      }
      image.onload = handler
      image.onerror = handler
      image.src = imgUrl
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes zoom {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.popup-wrp {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  .popup-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(33, 37, 45, 0.8);
    overflow: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .popup-content {
    width: 500px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: zoom 0.4s; // 添加了图片放大的效果
    position: relative;
    .img-bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .img-close {
      width: 32px;
      height: 32px;
      object-fit: cover;
      position: absolute;
      right: -32px;
      top: -32px;
    }
    .confirm-btn {
      width: 250px;
      height: 70px;
      bottom: 34px;
      position: absolute;
      left: 178px;
    }
  }
}
</style>
